import React from 'react';
import { styled } from '@withjoy/joykit';
import { INavTheme } from './Workspace';
import { DarkModeIcon } from './icons/DarkModeIcon';

const ToggleButton = styled.button<{
  $theme: INavTheme;
}>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: ${props => props.$theme.font};
  font-size: 16px;
  padding: 8px;
  transition: color 0.3s ease;

  &:hover {
    color: ${props => props.$theme.font};
  }
`;
export interface ThemeToggleProps {
  theme: INavTheme;
  onToggle: () => void;
}
export const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme, onToggle }) => {
  return (
    <ToggleButton
      $theme={theme}
      onClick={onToggle}
    >
      <DarkModeIcon fillColor={theme.accent} />
    </ToggleButton>
  );
};
